import Modules from '@/config/modules';
import Fx from '@/fx/Fx';

class Menu {
    // menuMap = {};
    menuList = [];
    init()
    {
        let moduleMenus = {};
        Modules.forEach((module, i)=>
        {
            let moduleMenu = require('../modules/'+module+'/menu');
            if(moduleMenu && moduleMenu.default)
            {
                console.log(moduleMenu);
                // appRouter = Fx.mergeDeep(appRouter, moduleRouter.default);
                moduleMenus = Fx.mergeDeep(moduleMenus, moduleMenu.default);
            }
        });

        console.log('moduleMenus:',moduleMenus);
        let me = this;
        function mapMenu(menus, parentKey)
        {
            let subMenus = [];
            Object.keys(menus).forEach((menuKey, i)=>
            {
                let menuFullKey = (parentKey? parentKey + ".": '')+menuKey;
                console.log(menuFullKey);
                let menuItem = menus[menuKey];
                menuItem['menuKey'] = menuFullKey;
                // me.menuMap[menuFullKey] = menuItem;
                // me.menuMap[menuItem.path] = menuItem;
                if(menuItem['children'])
                {
                    let childrens = menuItem['children'];
                    menuItem['subMenus'] = mapMenu(childrens, menuFullKey);
                }
                subMenus.push(menuItem);
            });
            subMenus.sort((m1, m2)=> m1.sortOrder-m2.sortOrder);
            return subMenus;
        }
        this.menuList = mapMenu(moduleMenus, '');
        // console.log('menuList',this.menuList, this.menuMap);
    }
    getMenuList()
    {
        return this.menuList;
    }
    // getMenuByKey(menuKey)
    // {
    //     return this.menuMap[menuKey];
    // }
}
let menu = new Menu();
menu.init();
export default menu;



// WEBPACK FOOTER //
// ./src/config/menu.js